<template>
	<div class="appeal">
		<div class="header">
			<el-row>
				<el-col :span="4">
					<label class="headerlabel">处理状态</label>
					<el-select v-model="param.status" placeholder="请选择处理状态">
						<el-option label="待处理" value="0"></el-option>
						<el-option label="已处理" value="1"></el-option>
					</el-select>
				</el-col>

				<el-col :span="4">
					<label class="headerlabel">创建时间</label>
					<el-date-picker class="autowidth" clearable v-model="FollowUpDate" @change="setDate()" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				</el-col>
				<el-col :span="4">
					<el-button type="primary" style="margin-left: 24px" @click="init">筛选</el-button>
					<el-button @click="reset">重置条件</el-button>
				</el-col>
			</el-row>
		</div>

		<main class="MainContent">
			<div>
				<el-button type="primary" @click="btnadd()" v-if="!ismanager" class="addbtn">新建诉求</el-button>
			</div>

			<el-table :data="MemberData" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" style="width: 100%; margin-bottom: 20px">
				<el-table-column label="序号" width="60px" align="left">
					<template slot-scope="scope">
						{{ (param.pageIndex - 1) * param.pageSize + scope.$index + 1 }}
					</template>
				</el-table-column>
				<el-table-column prop="realName" label="用户昵称"></el-table-column>
				<el-table-column prop="description" label="诉求内容"></el-table-column>
				<el-table-column label="处理状态">
					<template slot-scope="scope">
						<span :style="scope.row.status == 0 ? 'color: rgba(255, 141, 26, 1);' : 'color: rgba(11, 191, 98, 1);'">{{ scope.row.status == 0 ? '待处理' : '已处理' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="处理人">
					<template slot-scope="scope">
						{{ scope.row.solverName == null ? '--' : scope.row.solverName }}
					</template>
				</el-table-column>
				<el-table-column prop="phone" label="手机号码"></el-table-column>
				<el-table-column prop="createDate" label="创建时间">
					<template slot-scope="scope">
						{{ formatISODate(scope.row.createDate) }}
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" v-if="ismanager && scope.row.status == 0" @click="disposerow(scope.row)">处理</el-button>
						<el-button type="text" v-else-if="ismanager && scope.row.status == 1" @click="examinerow(scope.row)">查看</el-button>
						<el-button type="text" v-else @click="updaterow(scope.row)">查看</el-button>
						<!-- <el-button type="text" @click="deleterow(scope.row.requestKey)" style="margin-right: 20px">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :hide-on-single-page="true" @current-change="handleinitialization" :current-page.sync="param.pageNum" :page-size="param.pageSize" layout="total, prev, pager, next" :total="param.PageTotal"></el-pagination>
		</main>

		<el-dialog title="服务诉求" :visible.sync="disposeDialogVisible" width="30%" center v-loading="iuformloading">
			<el-form label-width="80px" style="width: 100%" ref="form" :rules="rules" :model="form">
				<el-form-item label="诉求内容">
					{{ form.description }}
				</el-form-item>

				<el-form-item label="处理反馈" prop="result">
					<el-input type="textarea" v-model="form.result"></el-input>
				</el-form-item>

				<el-form-item label="">
					<div>快捷短语</div>
					<div class="marked" @click="form.result = '感谢您的反馈，我们会努力改进，提升您的使用体验。'">感谢您的反馈，我们会努力改进，提升您的使用体验。</div>
					<div class="marked" @click="form.result = '您的建议已收到，我们会认真考虑并作出相应调整。'">您的建议已收到，我们会认真考虑并作出相应调整。</div>
					<div class="marked" @click="form.result = '感谢您的宝贵意见，我们会持续优化平台功能。'">感谢您的宝贵意见，我们会持续优化平台功能。</div>
					<div class="marked" @click="form.result = '您的反馈对我们很重要，我们会尽快改进不足之处。'">您的反馈对我们很重要，我们会尽快改进不足之处。</div>
					<div class="marked" @click="form.result = '感谢您的反馈，我们会不断提升服务质量，让您满意。'">感谢您的反馈，我们会不断提升服务质量，让您满意。</div>
				</el-form-item>

				<div></div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="disposeDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit()">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="服务诉求" :visible.sync="centerDialogVisible" width="20%" center v-loading="iuformloading">
			<el-form label-width="80px" style="width: 400px" ref="form" :rules="rules" :model="form">
				<el-form-item label="诉求内容 " prop="description">
					<el-input type="textarea" v-model="form.description"></el-input>
				</el-form-item>

				<el-form-item label="手机号" prop="phone">
					<el-input v-model="form.phone"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit()">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="服务诉求详情" :visible.sync="examineDialogVisible" width="20%" class="examine" center v-loading="iuformloading">
			<el-form label-width="90px" style="width: 400px" ref="form" :rules="rules" :model="form">
				<el-form-item label="诉求人员 ： " v-if="ismanager">
					{{ form.realName }}
				</el-form-item>

				<el-form-item label="诉求内容 ：">
					{{ form.description }}
				</el-form-item>

				<el-form-item label="手机号 ：" v-if="ismanager">
					{{ form.phone }}
				</el-form-item>

				<el-form-item label="诉求时间 ：" v-if="ismanager">
					{{ formatISODate(form.createDate) }}
				</el-form-item>

				<el-form-item label="处理反馈 ：">
					{{ form.solveResult }}
				</el-form-item>

				<el-form-item label="处理人 ：">
					{{ form.solverName }}
				</el-form-item>

				<el-form-item label="处理时间 ：">
					{{ formatISODate(form.solveDate) }}
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="examineDialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				Finalpaymenttime: [],
				centerDialogVisible: false,
				loading: false,
				disposeDialogVisible: false,
				iuformloading: false,
				examineDialogVisible: false,
				FollowUpDate: [],
				param: {
					status: '',
					from: '',
					to: '',
					pageIndex: 1,
					pageSize: 10,
					PageTotal: 0,
				},
				ismanager: true,
				MemberData: [],
				searchValue: '',
				MemeberPackageData: [],
				form: {
					complaintKey: '',
					description: '', //内容
					phone: '', //手机号
					result: '',
				},
				rules: {
					result: [{ required: true, message: '请输入内容', trigger: 'change' }],
					description: [{ required: true, message: '请输入内容', trigger: 'blur' }],
					phone: [
						{ required: true, message: '请输入手机号', trigger: 'blur' },
						{
							pattern: /^1[3456789]\d{9}$/,
							message: '手机号格式不正确',
							trigger: 'blur',
						},
					],
				},
				result: '',
			};
		},
		watch: {
			Finalpaymenttime(newval, oldval) {
				if (newval == null) {
					this.param.startExpiration = '';
					this.param.endExpiration = '';
				} else {
					this.param.startExpiration = newval[0];
					this.param.endExpiration = newval[1];
				}
			},
			// form: {
			// 	handler(newval, oldval) {
			// 		this.form.result = newval;
			// 		console.log(newval);
			// 	},
			// 	deep: true,
			// },
		},
		mounted() {
			this.ismanager = sessionStorage.getItem('entity') == '管理员' ? true : false;
			this.init();
		},
		methods: {
			// 查询会员类型(会员套餐接口)
			setDate() {
				this.param.from = this.FollowUpDate[0];
				this.param.to = this.FollowUpDate[1];
			},
			btnadd() {
				this.centerDialogVisible = true;
				this.form = {
					complaintKey: '',
					description: '', //内容
					phone: '', //手机号
					result: '',
				};
			},
			updateResult(text) {
				this.form.result = text;
				debugger;
			},
			updaterow(row) {
				this.centerDialogVisible = true;
				this.form = row;
			},
			disposerow(row) {
				this.disposeDialogVisible = true;
				this.form.complaintKey = row.complaintKey;
				this.form.description = row.description;
			},
			examinerow(row) {
				this.examineDialogVisible = true;
				this.form = row;
			},
			formatISODate(isoString) {
				let date = new Date(isoString);
				let year = date.getFullYear();
				let month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
				let day = String(date.getDate()).padStart(2, '0');
				let hours = String(date.getHours()).padStart(2, '0');
				let minutes = String(date.getMinutes()).padStart(2, '0');
				let seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			submit() {
				this.iuformloading = true;
				if (this.form.result != '') {
					this.$Http_Post('/servicecomplaint/handle', this.form).then((res) => {
						this.loading = false;
						if (res.Code == 0 || res.Code == 200) {
							this.$message({
								type: 'success',
								message: '处理成功!',
							});
							this.disposeDialogVisible = false;
							this.init();
						} else {
							this.$message.error(res.Message);
						}
						this.iuformloading = false;
					});
				} else {
					this.$Http_Post('/servicecomplaint/add', this.form).then((res) => {
						this.loading = false;
						if (res.Code == 0 || res.Code == 200) {
							this.$message({
								type: 'success',
								message: '添加成功!',
							});

							this.centerDialogVisible = false;
							this.init();
						} else {
							this.$message.error(res.Message);
						}
						this.iuformloading = false;
					});
				}

				// this.$Http_Post('/ServiceFollowUp/PostUpdateFollowUp', this.form).then((res) => {
				// 	this.loading = false;
				// 	if (res.Code == 0 || res.Code == 200) {
				// 		this.$message({
				// 			type: 'success',
				// 			message: '成功跟进!',
				// 		});
				// 		this.centerDialogVisible = false;
				// 		this.init();
				// 	} else {
				// 		this.$message.error(res.Message);
				// 	}
				// 	this.iuformloading = false;
				// });
			},
			init() {
				this.loading = true;
				this.$Http_Post('/servicecomplaint/getlist', this.param).then((res) => {
					this.loading = false;
					if (res.Code == 0 || res.Code == 200) {
						this.param.PageTotal = res.Counts;
						this.MemberData = res.Data;
					} else {
						this.$message.error(res.Message);
					}
				});
			},
			reset() {
				this.param = {
					DeptName: '',
					FollowUpMethods: '',
					StartDate: '',
					EndDate: '',
					pageIndex: 1,
					pageSize: 10,
					PageTotal: 0,
				};
				this.FollowUpDate = [];
				this.init();
			},
			handleinitialization(val) {
				this.param.pageNum = val;
				this.init();
			},
			deleterow(row) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						this.$Http_Post('/ServiceFollowUp/PostDeleteFollowUp', {
							RequestKey: row,
						}).then((res) => {
							if (res.Code == 0 || res.Code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功!',
								});
								this.init();
							} else {
								this.$message({
									type: 'success',
									message: res.Message,
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除',
						});
					});
			},
		},
	};
</script>
<style>
	.appeal .header {
		background: #fff;
		padding: 20px;
	}
	.appeal .header .headerlabel {
		width: 90px;
		display: inline-block;
	}
	.appeal .header .autowidth {
		width: 240px;
	}
	.appeal .MainContent {
		background: #fff;
		padding: 20px 16px;
		margin: 16px 0;
	}
	.appeal .addbtn {
		margin-bottom: 10px;
	}
	.appeal .marked {
		background: rgba(240, 240, 240, 1);
		padding-left: 10px;
		border-radius: 5px;
		margin: 5px;
		cursor: pointer;
	}

	.appeal .examine .el-form-item {
		margin-bottom: 0px;
	}
	.appeal .examine .el-form-item__content {
		color: #333333;
	}
</style>
